'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBigNumber;

var _bn = require('bn.js');

var _bn2 = _interopRequireDefault(_bn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBigNumber(value) {
  return _bn2.default.isBN(value) ||
  // XXX Some libraries (cough *ethers* cough) wrap BigNumbers in a way
  // that breaks `isBN`; this is a workaround for that issue:
  value != null && Object.hasOwnProperty.call(value, '_bn') &&
  // eslint-disable-next-line no-underscore-dangle
  _bn2.default.isBN(value._bn);
}
//# sourceMappingURL=isBigNumber.js.map